import OapEventsNavigation from './code/Scripts/components/OapEventsNavigation.vue';

export default {
  components: {
    OapEventsNavigation,
  },
};
